import axios from 'axios'
import { API_ADDRESS } from 'config'
import { SuburbConfig } from 'config/constants/types'
import { CouncilsListing } from 'state/types'

export const getCouncilListingsEdit = async (ownerName: string, ownerId: string): Promise<CouncilsListing[]> => {
  // const url = `${API_ADDRESS}/admin/councils/csv-listings?suburbId=${suburbId}&ownerId=${ownerId}`
  console.log(ownerName)
  // const url = `${API_ADDRESS}/dashboard/suburb/data?ownerId=${ownerId}&suburbName=${ownerName}&dataType=listings`
  const url = `${API_ADDRESS}/dashboard/suburb/data?ownerId=${ownerId}&suburbName=${ownerName}&dataType=properties`
  const { data } = await axios.get(url)
  return data
}
